import type {KeyboardEventModifiers} from '../types';

export const SPECIAL_KEYS = Object.freeze({
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    ESCAPE:  'Escape',
    ENTER: 'Enter',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown'
});

export function isDeleteOrBackspace(key: string) {
    return key === SPECIAL_KEYS.DELETE || key === SPECIAL_KEYS.BACKSPACE;
}

export function isArrow(key: string): boolean {
    return ([SPECIAL_KEYS.ARROW_LEFT, SPECIAL_KEYS.ARROW_RIGHT, SPECIAL_KEYS.ARROW_UP, SPECIAL_KEYS.ARROW_DOWN] as readonly string[]).includes(key);
}

// assume that anything with length 1 is printable ('a', '9', '-')
// as opposed to control and special keys ('Enter', 'Digit1', 'keyQ')
export function isPrintableCharacterKey(key: string): boolean {
    return key.length === 1;
}

// ignore shift, others must not be active
export function allowOnlyShiftModifier(modifiers: KeyboardEventModifiers): boolean {
    return !modifiers.ctrlKey && !modifiers.altKey && !modifiers.metaKey;
}